
import React from 'react';
import Paper from '@material-ui/core/Paper';
import {
  Box,
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
  renderQR(data) {
    const selectedSearchValues = this.props.selectedSearchValues;
    if (!data || data.length === 0) return null;

    const { startNumber = 1 } = this.props;

    return data.map((d, index) => {
      const receiptNumber = startNumber + index;
      const formattedReceiptNumber = receiptNumber.toString().padStart(4, '0');

      return (
        <Paper key={index} elevation={0} style={{ width: '100%', height: '100%' }}>
          <div className="record-container" style={{ width: '100%', position: 'relative' }}>
            <div style={{ width: '100%', display: 'flex' }}>
              <div className="table-responsive row-top-gapp" style={{ width: '45%', marginLeft: 0 }}>
                <div style={{ width: '100%' }}>
                  <div style={{ textAlign: 'center', width: '100%' }}>
                    <div style={{ textAlign: 'center', fontSize: '35px', fontWeight: 'bold', marginTop: '20px' }}>ග්‍රීන් ෆීල්ඩ් බයෝ ප්ලාන්ටේෂන්ස් පුද්ගලික සමාගම</div>
                    <div style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bold' }}> {selectedSearchValues.factoryName}, {d.facoryAddress}</div>
                    <div style={{ textAlign: 'center', fontSize: '25px' }}><u>අමු තේ දළු සැපයුම් සදහා ගෙවීම් රිසිට්පත</u></div>
                    <div style={{ textAlign: 'right', fontSize: '25px' }}>NO {formattedReceiptNumber}</div>
                  </div>
                  <br />
                  <div style={{ width: '100%' }}>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>මාසය :</b> {moment(selectedSearchValues.month).format('MMMM')}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>අවුරුද්ද :</b> {selectedSearchValues.year}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>තේ දළු සපයන්නා :</b> {d.firstName}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>ලිපිනය :</b> {d.address}</div>
                  </div>
                </div>
                <br />
                <table style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු වර්ගය</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු සැපයූ ප්‍රමාණය </th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු කි.ග්‍රෑ එකක මිල</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>මුළු මුදල</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px' }}>සමාන්‍ය දළු</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.normalQuantity).toFixed(2)}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.normalLeafRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>
                        {(parseFloat(d.normalQuantity) * (d.normalLeafRate)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px' }}>සුපිරි දළු</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.superQuantity).toFixed(2)}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.superLeafRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>
                        {(parseFloat(d.superQuantity) * parseFloat(d.superLeafRate)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <br />

                <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%', marginBottom: '20px', padding: '8px' }}>
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ලැබීම්</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.exportNumber}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ප්‍රවාහන ගාස්තුව</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.transport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>මුළු මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {(
                          (parseFloat(d.normalQuantity * d.normalLeafRate) + parseFloat(d.superQuantity * d.superLeafRate)) + parseFloat(d.transport)
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවිය යුතු ණය</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.loanOutstanding.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ණය සදහා මෙම මස වාරිකය</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.installmentLoneForMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>අත්තිකාරම් මුදල</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.advance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>තේ සදහ අය විය යුතු මුදල</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.amountForTea.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ප්‍රවාහන ගාස්තුව</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.transport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>යෙදවුම්</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.data}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>වෙනත්</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.other.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවිය යුතු මුළු මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {((
                          parseFloat(d.installmentLoneForMonth) +
                          parseFloat(d.advance) +
                          parseFloat(d.amountForTea) +
                          parseFloat(d.transport) +
                          parseFloat(d.other)
                        )
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවූ ඉතිරි මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {(
                          (
                            (parseFloat(d.normalQuantity * d.normalLeafRate) + parseFloat(d.superQuantity * d.superLeafRate)) + parseFloat(d.transport)
                          ) - (
                            parseFloat(d.installmentLoneForMonth) +
                            parseFloat(d.advance) +
                            parseFloat(d.amountForTea) +
                            parseFloat(d.transport) +
                            parseFloat(d.other)
                          )
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}></td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}></td>
                    </tr>
                  </tbody>
                </table>

                <Box minWidth={1050}>
                  <div style={{ textAlign: 'center', fontSize: '20px', marginTop: '20px', width: '90%' }}>
                    වර්ෂ 1957 අංක 51 දරන තේ පාලන පනත අනුව දළු සපයන්නා සිදු කරන ප්‍රකාශයයි.
                  </div>
                  <br />
                  <div style={{ textAlign: 'center', fontSize: '20px', marginTop: '20px', width: '90%' }}>
                    මා විසින් මාගේ ඉඩමෙන් නෙලා ගත් දළු --------------------- (KGS ) උක්ත කම්හලට භාර දුන් බවට ප්‍රකාශ කරමි.
                    උක්ත කම්හලට භාර දුන් බවට ප්‍රකාශ කරමි.
                  </div>
                </Box>
                <div></div>
                <br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '20px auto', padding: '20px' }}>
                  <div style={{ textAlign: 'left', fontSize: '20px', flex: '1' }}>
                    <div>---------------------------------</div>
                    <div>සපයන්නාගේ අත්සන</div>
                    <br />
                    <br />
                    <br />
                    <div>දිනය .............................................</div>
                  </div>
                  <div style={{ textAlign: 'right', fontSize: '20px', flex: '1' }}>
                    <div>---------------------------------</div>
                    <div >කළමනාකරු</div>
                  </div>
                </div>
              </div>
              <div style={{ marginRight: '9%' }}></div>

              <div className="table-responsive row-top-gapp" style={{ width: '45%', marginLeft: 0 }}>
                <div style={{ width: '100%' }}>
                  <div style={{ textAlign: 'center', width: '100%' }}>
                    <div style={{ textAlign: 'center', fontSize: '35px', fontWeight: 'bold', marginTop: '20px' }}>ග්‍රීන් ෆීල්ඩ් බයෝ ප්ලාන්ටේෂන්ස් පුද්ගලික සමාගම</div>
                    <div style={{ textAlign: 'center', fontSize: '25px', fontWeight: 'bold' }}> {selectedSearchValues.factoryName}, {d.facoryAddress}</div>
                    <div style={{ textAlign: 'center', fontSize: '25px' }}><u>අමු තේ දළු සැපයුම් සදහා ගෙවීම් රිසිට්පත</u></div>
                    <div style={{ textAlign: 'right', fontSize: '25px' }}>NO {formattedReceiptNumber}</div>
                  </div>
                  <br />
                  <div style={{ width: '100%' }}>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>මාසය :</b> {moment(selectedSearchValues.month).format('MMMM')}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>අවුරුද්ද :</b> {selectedSearchValues.year}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>තේ දළු සපයන්නා :</b> {d.firstName}</div>
                    <div style={{ fontSize: "20px", textAlign: "left" }}><b>ලිපිනය :</b> {d.address}</div>
                  </div>
                </div>
                <br />
                <table style={{ borderCollapse: 'collapse', width: '100%', border: '1px solid black' }}>
                  <thead>
                    <tr>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු වර්ගය</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු සැපයූ ප්‍රමාණය </th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>දළු කි.ග්‍රෑ එකක මිල</th>
                      <th style={{ border: '1px solid black', padding: '8px', fontSize: '20px', fontWeight: 'bold' }}>මුළු මුදල</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px' }}>සමාන්‍ය දළු</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.normalQuantity).toFixed(2)}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.normalLeafRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>
                        {(parseFloat(d.normalQuantity) * (d.normalLeafRate)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px' }}>සුපිරි දළු</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.superQuantity).toFixed(2)}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>{parseFloat(d.superLeafRate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td style={{ border: '1px solid black', padding: '8px', fontSize: '20px', textAlign: 'right' }}>
                        {(parseFloat(d.superQuantity) * parseFloat(d.superLeafRate)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <br />
                <br />

                <table style={{ border: '1px solid black', borderCollapse: 'collapse', width: '100%', marginBottom: '20px', padding: '8px' }}>
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ලැබීම්</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.exportNumber}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ප්‍රවාහන ගාස්තුව</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.transport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>මුළු මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {(
                          (parseFloat(d.normalQuantity * d.normalLeafRate) + parseFloat(d.superQuantity * d.superLeafRate)) + parseFloat(d.transport)
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවිය යුතු ණය</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.loanOutstanding.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ණය සදහා මෙම මස වාරිකය</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.installmentLoneForMonth.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>අත්තිකාරම් මුදල</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.advance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>තේ සදහ අය විය යුතු මුදල</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.amountForTea.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>ප්‍රවාහන ගාස්තුව</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.transport.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>යෙදවුම්</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.data}</td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}>වෙනත්</td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>{d.other.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවිය යුතු මුළු මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {((
                          parseFloat(d.installmentLoneForMonth) +
                          parseFloat(d.advance) +
                          parseFloat(d.amountForTea) +
                          parseFloat(d.transport) +
                          parseFloat(d.other)
                        )
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px' }}>ගෙවූ ඉතිරි මුදල</td>
                      <td style={{ fontWeight: 'bold', fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}>
                        {(
                          (
                            (parseFloat(d.normalQuantity * d.normalLeafRate) + parseFloat(d.superQuantity * d.superLeafRate)) + parseFloat(d.transport)
                          ) - (
                            parseFloat(d.installmentLoneForMonth) +
                            parseFloat(d.advance) +
                            parseFloat(d.amountForTea) +
                            parseFloat(d.transport) +
                            parseFloat(d.other)
                          )
                        ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </td>
                    </tr>

                    <tr>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px' }}></td>
                      <td style={{ fontSize: '20px', border: '1px solid black', padding: '8px', textAlign: 'right' }}></td>
                    </tr>
                  </tbody>
                </table>

                <Box minWidth={1050}>
                  <div style={{ textAlign: 'center', fontSize: '20px', marginTop: '20px', width: '90%' }}>
                    වර්ෂ 1957 අංක 51 දරන තේ පාලන පනත අනුව දළු සපයන්නා සිදු කරන ප්‍රකාශයයි.
                  </div>
                  <br />
                  <div style={{ textAlign: 'center', fontSize: '20px', marginTop: '20px', width: '90%' }}>
                    මා විසින් මාගේ ඉඩමෙන් නෙලා ගත් දළු --------------------- (KGS ) උක්ත කම්හලට භාර දුන් බවට ප්‍රකාශ කරමි.
                    උක්ත කම්හලට භාර දුන් බවට ප්‍රකාශ කරමි.
                  </div>
                </Box>

                <div></div>
                <br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', margin: '20px auto', padding: '20px' }}>
                  <div style={{ textAlign: 'left', fontSize: '20px', flex: '1' }}>
                    <div>---------------------------------</div>
                    <div>සපයන්නාගේ අත්සන</div>
                    <br />
                    <br />
                    <br />
                    <div>දිනය .............................................</div>
                  </div>
                  <div style={{ textAlign: 'right', fontSize: '20px', flex: '1' }}>
                    <div>---------------------------------</div>
                    <div >කළමනාකරු</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Paper>
      );
    });
  }

  render() {
    const renderedQR = this.renderQR(this.props.supplierData);
    return (
      <div>
        {renderedQR}
      </div>
    );
  }
}
